(function () {
  'use strict';

  /* =========================================================
     GLOBAL VARIABLES
  ========================================================= */

  var CTM_PRIVACY_KEY = 'ctm_privacy_accepted';
  var ctmActiveSheet = null;

  var pdpSizeFieldset = null;
  var pdpLastSelectedValue = null;


  /* =========================================================
     COMMON HELPERS
  ========================================================= */

  function qs(selector, parent) {
    return (parent || document).querySelector(selector);
  }

  function qsa(selector, parent) {
    return Array.from(
      (parent || document).querySelectorAll(selector)
    );
  }

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function isPDP() {
    return /\/products\//.test(window.location.pathname);
  }


  /* =========================================================
     PDP BUTTON HELPERS
  ========================================================= */

  function getPdpSubmitBtn() {
    return qs(
      '.cstm-buy-button-product button[type="submit"]'
    );
  }

  function getThemeStickySubmitBtn() {
    var stickyBar = qs('product-sticky-bar');

    if (!stickyBar) return null;

    return qs(
      'button[type="submit"]',
      stickyBar
    );
  }


  /* =========================================================
     BUTTON TEXT / LOADING
  ========================================================= */

  function setButtonState(button, selected) {
    if (!button) return;

    var selectText = qs(
      '.ctm-btn-select-size',
      button
    );

    var addText = qs(
      '.ctm-btn-add-to-bag',
      button
    );

    if (selectText) {
      selectText.style.display =
        selected ? 'none' : 'block';
    }

    if (addText) {
      addText.style.display =
        selected ? 'block' : 'none';
    }
  }


  /*
    UPDATED LOADING FUNCTION

    Supports:
    .ctm-qa-atb-btn
    .mobile-select-size-cstm
    .ctm-qa-atb-btn.mobile-select-size-cstm
  */

function showLoadingDots(button) {
  if (!button) return;

  var dots = qs(
    '.ctm-btn-loading-dots',
    button
  );

  var buttonName = qs(
    '.button-name-cstm',
    button
  );

  /*
    Save original HTML only once.
  */
  if (!button.dataset.ctmOriginalHtml) {
    button.dataset.ctmOriginalHtml =
      button.innerHTML;
  }

  /*
    Keep button width fixed while loading.
  */
  var width =
    button.getBoundingClientRect().width;

  if (width) {
    button.style.width =
      width + 'px';
  }

  /*
    If loading dots already exist,
    DO NOT hide .button-name-cstm.

    Instead:
    - Keep the parent visible
    - Hide Select Size / Add to Bag
    - Show loading dots
  */
  if (dots) {

    /*
      Make sure parent is visible.
    */
    if (buttonName) {
      buttonName.style.display =
        'inline-flex';
    }

    /*
      Hide normal button text.
    */
    qsa(
      '.ctm-btn-select-size, .ctm-btn-add-to-bag',
      button
    ).forEach(function (el) {

      el.style.display =
        'none';

    });

    /*
      Hide arrow while loading.
    */
    qsa(
      '.buttons-arrows',
      button
    ).forEach(function (el) {

      el.style.display =
        'none';

    });

    /*
      Show loading dots.
    */
    dots.style.display =
      'inline-flex';

    dots.classList.add(
      'ctm-is-visible'
    );

    return;
  }

  /*
    If dots do not exist,
    create them inside button-name-cstm.
  */
  if (!buttonName) {

    button.innerHTML =
      '<span class="button-name-cstm">' +
        '<span class="ctm-btn-loading-dots ctm-is-visible">' +
          '<span></span>' +
          '<span></span>' +
          '<span></span>' +
        '</span>' +
      '</span>';

    return;
  }

  var newDots =
    document.createElement('span');

  newDots.className =
    'ctm-btn-loading-dots ctm-is-visible';

  newDots.innerHTML =
    '<span></span>' +
    '<span></span>' +
    '<span></span>';

  buttonName.appendChild(
    newDots
  );

  /*
    Hide normal text.
  */
  qsa(
    '.ctm-btn-select-size, .ctm-btn-add-to-bag',
    button
  ).forEach(function (el) {

    el.style.display =
      'none';

  });

  buttonName.style.display =
    'inline-flex';

  newDots.style.display =
    'inline-flex';

  /*
    Hide arrow.
  */
  qsa(
    '.buttons-arrows',
    button
  ).forEach(function (el) {

    el.style.display =
      'none';

  });
}


function hideLoadingDots(button) {
  if (!button) return;

  /*
    If original HTML was saved,
    restore it.

    IMPORTANT:
    Do this for ALL buttons, not only
    .ctm-qa-atb-btn / .mobile-select-size-cstm.
  */
  if (button.dataset.ctmOriginalHtml) {

    button.innerHTML =
      button.dataset.ctmOriginalHtml;

    delete button.dataset.ctmOriginalHtml;

  }

  /*
    Reset button width.
  */
  button.style.width = '';

  /*
    After restoring HTML, make sure
    the button content is visible.
  */
  var buttonName =
    qs(
      '.button-name-cstm',
      button
    );

  if (buttonName) {
    buttonName.style.display = '';
  }

  /*
    Remove inline display values from
    normal button text.
  */
  qsa(
    '.ctm-btn-select-size, .ctm-btn-add-to-bag',
    button
  ).forEach(function (el) {

    el.style.display = '';

  });

  /*
    Restore arrow.
  */
  qsa(
    '.buttons-arrows',
    button
  ).forEach(function (el) {

    el.style.display = '';

  });

  /*
    Hide loader.
  */
  qsa(
    '.ctm-btn-loading-dots',
    button
  ).forEach(function (dots) {

    dots.classList.remove(
      'ctm-is-visible'
    );

    dots.style.display = '';

  });
}

  function showTemporaryLoading(
    button,
    callback,
    duration
  ) {
    if (!button) {
      if (callback) callback();
      return;
    }

    showLoadingDots(button);

    if (callback) {
      callback();
    }

    setTimeout(function () {
      hideLoadingDots(button);

      var pdpBtn =
        getPdpSubmitBtn();

      var selected =
        pdpBtn &&
        !pdpBtn.hasAttribute(
          'data-ctm-unselected'
        );

      setButtonState(
        button,
        selected
      );
    }, duration || 800);
  }


  /* =========================================================
     CART
  ========================================================= */

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {

        qsa('[data-cart-count]')
          .forEach(function (el) {
            el.textContent =
              cart.item_count;
          });

        qsa('cart-count')
          .forEach(function (el) {
            el.textContent =
              cart.item_count;
          });

        var headerCount =
          qs('.Header__CartCount');

        if (headerCount) {
          headerCount.textContent =
            cart.item_count > 0
              ? cart.item_count
              : '';
        }
      })
      .catch(function () {});
  }


  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json'
      },
      body: JSON.stringify({
        id: parseInt(
          variantId,
          10
        ),
        quantity: 1
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {

        if (data.status === 422) {
          throw new Error(
            data.description
          );
        }

        updateCartCount();

        return data;
      });
  }


  /* =========================================================
     CART DRAWER
  ========================================================= */

  window.ctmOpenCart = function () {

    var drawer =
      qs('cart-drawer');

    if (!drawer) return;

    var sectionWrapper =
      drawer.closest(
        '[id^="shopify-section-"]'
      );

    var sectionId =
      sectionWrapper
        ? sectionWrapper.id.replace(
            'shopify-section-',
            ''
          )
        : 'cart-drawer';

    var root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    Promise.all([
      fetch(
        root + 'cart.js'
      ).then(function (r) {
        return r.json();
      }),

      fetch(
        root +
        '?section_id=' +
        sectionId
      ).then(function (r) {
        return r.text();
      })
    ])
      .then(function (results) {

        var cart = results[0];
        var sectionHtml =
          results[1];

        cart.sections = {};
        cart.sections[sectionId] =
          sectionHtml;

        document.documentElement.dispatchEvent(
          new CustomEvent(
            'cart:change',
            {
              bubbles: true,
              detail: {
                baseEvent:
                  'variant:add',
                cart: cart
              }
            }
          )
        );
      })
      .catch(function () {

        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh',
            {
              bubbles: true
            }
          )
        );

        if (
          typeof drawer.show ===
          'function'
        ) {
          drawer.show();
        }
        else if (
          typeof drawer.open ===
          'function'
        ) {
          drawer.open();
        }
      });
  };


  /* =========================================================
     PRIVACY BANNER
  ========================================================= */

  function hidePrivacyBanner() {

    var banner =
      qs('privacy-banner');

    if (!banner) return;

    var visible =
      banner.classList.contains(
        'pop-in--visible'
      ) ||
      banner.style.display !==
        'none' ||
      banner.hasAttribute('open');

    if (!visible) return;

    banner.classList.remove(
      'pop-in--visible'
    );

    banner.style.display =
      'none';

    if (
      typeof banner.hide ===
      'function'
    ) {
      try {
        banner.hide();
      } catch (e) {}
    }
  }


  function initPrivacyBanner() {

    var banner =
      qs('privacy-banner');

    if (!banner) return;

    if (
      localStorage.getItem(
        CTM_PRIVACY_KEY
      ) === '1'
    ) {

      hidePrivacyBanner();

      new MutationObserver(
        hidePrivacyBanner
      ).observe(
        banner,
        {
          attributes: true,
          attributeFilter: [
            'open',
            'class',
            'style'
          ]
        }
      );
    }

    banner.addEventListener(
      'click',
      function (e) {

        if (
          e.target.closest(
            '[data-action="accept"]'
          )
        ) {

          localStorage.setItem(
            CTM_PRIVACY_KEY,
            '1'
          );

          hidePrivacyBanner();
        }
      }
    );
  }


  /* =========================================================
     THEME PRODUCT STICKY BAR
  ========================================================= */

  function updateThemeStickyVisibility() {

    var stickyBar =
      qs('product-sticky-bar');

    var atcBtn =
      getPdpSubmitBtn();

    if (
      !stickyBar ||
      !atcBtn
    ) {
      return;
    }

    var rect =
      atcBtn.getBoundingClientRect();

    stickyBar.classList.toggle(
      'ctm-sticky-visible',
      rect.bottom < 0
    );
  }


  function initThemeStickyBar() {

    if (
      !qs('product-sticky-bar')
    ) {
      return;
    }

    window.addEventListener(
      'scroll',
      updateThemeStickyVisibility,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      updateThemeStickyVisibility,
      {
        passive: true
      }
    );

    setTimeout(
      updateThemeStickyVisibility,
      300
    );
  }


  /* =========================================================
     PDP SIZE FIELDSET
  ========================================================= */

  function getPdpSizeFieldset() {

    var picker =
      qs('variant-picker');

    if (!picker) return null;

    var fieldset = null;

    qsa(
      'fieldset.variant-picker__option',
      picker
    ).forEach(function (fs) {

      var legend =
        qs('legend', fs);

      if (
        legend &&
        /size/i.test(
          legend.textContent.trim()
        )
      ) {
        fieldset = fs;
      }
    });

    return fieldset;
  }


  function getPdpSizeRadios() {

    if (!pdpSizeFieldset) {
      return [];
    }

    return qsa(
      'input[type="radio"]',
      pdpSizeFieldset
    );
  }


  function scrollToSizeIfNeeded() {

    if (!pdpSizeFieldset) return;

    var rect =
      pdpSizeFieldset.getBoundingClientRect();

    var fullyVisible =
      rect.top >= 0 &&
      rect.bottom <=
        window.innerHeight;

    if (!fullyVisible) {

      pdpSizeFieldset.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }


  // function markClickedSize(value) {

  //   if (
  //     !pdpSizeFieldset ||
  //     !value
  //   ) {
  //     return;
  //   }

  //   qsa(
  //     'label, .block-swatch',
  //     pdpSizeFieldset
  //   ).forEach(function (el) {
  //     el.classList.remove(
  //       'ctm-just-clicked'
  //     );
  //   });

  //   var radio =
  //     getPdpSizeRadios().find(
  //       function (r) {
  //         return r.value === value;
  //       }
  //     );

  //   if (!radio) return;

  //   var label =
  //     radio.closest('label') ||
  //     qs(
  //       'label[for="' +
  //       radio.id +
  //       '"]',
  //       pdpSizeFieldset
  //     );

  //   if (label) {
  //     label.classList.add(
  //       'ctm-just-clicked'
  //     );
  //   }
  // }
function markClickedSize(value) {

  if (!pdpSizeFieldset || !value) {
    return;
  }

  var radio = getPdpSizeRadios().find(function (r) {
    return r.value === value;
  });

  if (!radio) {
    return;
  }

  var label =
    radio.closest('label') ||
    qs(
      'label[for="' + radio.id + '"]',
      pdpSizeFieldset
    );

  if (!label) {
    return;
  }

  var current = qs(
    '.ctm-just-clicked',
    pdpSizeFieldset
  );

  if (current && current !== label) {
    current.classList.remove('ctm-just-clicked');
  }

  label.classList.add('ctm-just-clicked');
}

  function setPdpSelected() {

    var submitBtn =
      getPdpSubmitBtn();

    if (!submitBtn) return;

    submitBtn.removeAttribute(
      'data-ctm-unselected'
    );

    if (pdpSizeFieldset) {
      pdpSizeFieldset.classList.remove(
        'ctm-size-val-error'
      );
    }

    setButtonState(
      submitBtn,
      true
    );

    setButtonState(
      getThemeStickySubmitBtn(),
      true
    );
  }


  function setPdpUnselected() {

    var submitBtn =
      getPdpSubmitBtn();

    if (
      !submitBtn ||
      !pdpSizeFieldset
    ) {
      return;
    }

    getPdpSizeRadios()
      .forEach(function (radio) {
        radio.checked = false;
      });

    submitBtn.setAttribute(
      'data-ctm-unselected',
      '1'
    );

    setButtonState(
      submitBtn,
      false
    );

    setButtonState(
      getThemeStickySubmitBtn(),
      false
    );

    var stickyBar =
      qs('product-sticky-bar');

    if (!stickyBar) return;

    var count = 0;

    var interval =
      setInterval(function () {

        if (
          !submitBtn.hasAttribute(
            'data-ctm-unselected'
          ) ||
          count++ >= 25
        ) {
          clearInterval(
            interval
          );
          return;
        }

        qsa(
          'input[type="radio"]',
          stickyBar
        ).forEach(function (radio) {
          radio.checked = false;
        });

        qsa(
          '.ctm-ss-pill, ' +
          '.option-value, ' +
          '.block-swatch, ' +
          '[class*="option-value"]',
          stickyBar
        ).forEach(function (el) {

          el.classList.remove(
            'is-selected'
          );

          if (
            el.hasAttribute(
              'aria-checked'
            )
          ) {
            el.setAttribute(
              'aria-checked',
              'false'
            );
          }
        });

      }, 200);
  }


  /* =========================================================
     PDP VARIANT RE-APPLY
  ========================================================= */

  function reapplyPdpSelection() {

    var freshFieldset =
      getPdpSizeFieldset();

    if (freshFieldset) {
      pdpSizeFieldset =
        freshFieldset;
    }

    var freshButton =
      getPdpSubmitBtn();

    if (
      !pdpSizeFieldset ||
      !freshButton ||
      !pdpLastSelectedValue
    ) {
      return;
    }

    var radio =
      getPdpSizeRadios().find(
        function (r) {
          return (
            r.value ===
            pdpLastSelectedValue
          );
        }
      );

    if (!radio) return;

    markClickedSize(
      pdpLastSelectedValue
    );

    setPdpSelected();
  }


  /* =========================================================
     PDP VARIANT INITIALIZATION
  ========================================================= */

  function initPdpVariantLogic() {

    if (!isPDP()) return;

    pdpSizeFieldset =
      getPdpSizeFieldset();

    if (!pdpSizeFieldset) return;

    var urlVariant =
      new URLSearchParams(
        window.location.search
      ).get('variant');

    var radios =
      getPdpSizeRadios();

    var preselected =
      urlVariant
        ? radios.find(function (r) {
            return r.checked;
          })
        : null;

    if (preselected) {

      pdpLastSelectedValue =
        preselected.value;

      markClickedSize(
        pdpLastSelectedValue
      );

      setPdpSelected();

    } else {

      setTimeout(
        setPdpUnselected,
        200
      );
    }


    /* Shopify AJAX replacement observer */

    var root =
      pdpSizeFieldset.closest(
        '.product-info__block-list'
      ) ||
      pdpSizeFieldset.parentElement ||
      document.body;

    var timer = null;

    new MutationObserver(
      function () {

        clearTimeout(timer);

        // timer = setTimeout(
        //   reapplyPdpSelection,
        //   30
        // );
new MutationObserver(function () {

  var freshButton = getPdpSubmitBtn();

  // Immediately force the newly rendered button
  if (freshButton && pdpLastSelectedValue) {
    freshButton.removeAttribute('data-ctm-unselected');
    setButtonState(freshButton, true);
    setButtonState(getThemeStickySubmitBtn(), true);
  }

  clearTimeout(timer);

  timer = setTimeout(reapplyPdpSelection, 0);

}).observe(root, {
  childList: true,
  subtree: true
});
      }
    ).observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /* =========================================================
     PDP SIZE CLICK
  ========================================================= */

  // function handlePdpSizeClick(e) {

  //   if (!pdpSizeFieldset) return;

  //   var clicked =
  //     e.target.closest(
  //       'label, input[type="radio"]'
  //     );

  //   if (
  //     !clicked ||
  //     !pdpSizeFieldset.contains(
  //       clicked
  //     )
  //   ) {
  //     return;
  //   }

  //   var radio = null;

  //   if (
  //     clicked.tagName ===
  //     'INPUT'
  //   ) {
  //     radio = clicked;
  //   } else {

  //     var forId =
  //       clicked.getAttribute(
  //         'for'
  //       );

  //     if (forId) {
  //       radio =
  //         document.getElementById(
  //           forId
  //         );
  //     }
  //   }

  //   if (!radio) return;

  //   pdpLastSelectedValue =
  //     radio.value;

  //   markClickedSize(
  //     pdpLastSelectedValue
  //   );

  //   // setTimeout(function () {

  //   //   var selected =
  //   //     getPdpSizeRadios()
  //   //       .some(function (r) {
  //   //         return r.checked;
  //   //       });

  //   //   if (selected) {
  //   //     setPdpSelected();
  //   //   }

  //   // }, 40);
  //   setPdpSelected();
  // }
function handlePdpSizeClick(e) {

  if (!pdpSizeFieldset) return;

  var clicked =
    e.target.closest(
      'label, input[type="radio"]'
    );

  if (
    !clicked ||
    !pdpSizeFieldset.contains(clicked)
  ) {
    return;
  }

  var radio = null;

  /*
    If clicked directly on radio
  */
  if (clicked.tagName === 'INPUT') {

    radio = clicked;

  } else {

    /*
      If clicked on label,
      find connected radio
    */
    var forId =
      clicked.getAttribute('for');

    if (forId) {
      radio =
        document.getElementById(forId);
    }
  }

  if (!radio) return;


  /* =====================================================
     DISABLED / SOLD OUT
     DO NOTHING
  ===================================================== */

  if (
    radio.disabled ||
    radio.dataset.available === 'false' ||
    radio.getAttribute('data-available') === 'false'
  ) {

    /*
      IMPORTANT:
      Do NOT call:
      - setPdpSelected()
      - setPdpUnselected()
      - setButtonState()
      - anything that changes button text
    */

    return;
  }


  /* =====================================================
     AVAILABLE SIZE
  ===================================================== */

  pdpLastSelectedValue =
    radio.value;

  markClickedSize(
    pdpLastSelectedValue
  );

  setPdpSelected();
}

  /* =========================================================
     PDP SUBMIT VALIDATION
  ========================================================= */

  function handlePdpSubmit(e) {

    var button =
      e.target.closest(
        '.cstm-buy-button-product button[type="submit"]'
      );

    if (!button) return;

    if (
      !button.hasAttribute(
        'data-ctm-unselected'
      )
    ) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (pdpSizeFieldset) {
      pdpSizeFieldset.classList.add(
        'ctm-size-val-error'
      );
    }

    showTemporaryLoading(
      button,
      scrollToSizeIfNeeded,
      700
    );
  }


  /* =========================================================
     THEME STICKY SUBMIT VALIDATION
  ========================================================= */

  function handleThemeStickySubmit(e) {

    var button =
      e.target.closest(
        'product-sticky-bar button[type="submit"]'
      );

    if (!button) return;

    var pdpButton =
      getPdpSubmitBtn();

    if (
      !pdpButton ||
      !pdpButton.hasAttribute(
        'data-ctm-unselected'
      )
    ) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (pdpSizeFieldset) {
      pdpSizeFieldset.classList.add(
        'ctm-size-val-error'
      );
    }

    showTemporaryLoading(
      button,
      scrollToSizeIfNeeded,
      700
    );
  }


  /* =========================================================
     STICKY SIZE PILL
  ========================================================= */

  function handleStickySizePill(e) {

    var pill =
      e.target.closest(
        '.ctm-ss-pill'
      );

    if (
      !pill ||
      pill.disabled
    ) {
      return;
    }

    if (
      pill.closest(
        'product-sticky-bar'
      )
    ) {
      return;
    }

    var position =
      pill.getAttribute(
        'data-option-position'
      );

    var value =
      pill.getAttribute(
        'data-value'
      );

    if (
      !position ||
      !value
    ) {
      return;
    }

    qsa(
      'input[name="option' +
      position +
      '"]'
    ).forEach(function (input) {

      if (
        input.value === value &&
        !input.closest(
          'collection-variant-picker'
        )
      ) {

        input.checked = true;

        input.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );
      }
    });
  }


  /* =========================================================
     QUICK ADD SHEET
  ========================================================= */

  function relocateQuickAddSheet(
    picker
  ) {

    if (
      !picker ||
      picker._ctmSheet
    ) {
      return;
    }

    var sheet =
      qs(
        '.ctm-qa-sheet',
        picker
      );

    if (!sheet) return;

    picker._ctmSheet =
      sheet;

    document.body.appendChild(
      sheet
    );
  }


  function relocateAllQuickAddSheets(
    root
  ) {

    qsa(
      'collection-variant-picker',
      root
    ).forEach(
      relocateQuickAddSheet
    );
  }


  function resetQuickAddSheet(
    sheet
  ) {

    if (!sheet) return;

    qsa(
      '.ctm-qa-size-box',
      sheet
    ).forEach(function (box) {

      box.classList.remove(
        'is-selected'
      );
    });

    qsa(
      '.ctm-qa-grid',
      sheet
    ).forEach(function (grid) {

      grid.classList.remove(
        'ctm-qa-grid-error'
      );
    });

    qsa(
      '.ctm-qa-select-label',
      sheet
    ).forEach(function (label) {

      label.classList.remove(
        'ctm-qa-label-error'
      );
    });

    var error =
      qs(
        '.ctm-qa-error-msg',
        sheet
      );

    if (error) {
      error.style.display =
        'none';
    }

    var button =
      qs(
        '.ctm-qa-atb-btn',
        sheet
      );

    if (button) {

      button.textContent =
        'Select Size';

      button.disabled = false;

      button.classList.remove(
        'ctm-qa-btn-error'
      );
    }
  }


  function closeQuickAddSheet(
    sheet
  ) {

    if (!sheet) return;

    sheet.classList.remove(
      'is-open'
    );
     document.body.classList.remove('ctm-overlay-is-open');

    resetQuickAddSheet(
      sheet
    );

    if (
      ctmActiveSheet ===
      sheet
    ) {
      ctmActiveSheet = null;
    }
  }


  function openQuickAddSheet(
    sheet
  ) {

    if (!sheet) return;

    if (
      sheet.parentNode !==
      document.body
    ) {
      document.body.appendChild(
        sheet
      );
    }

    ctmActiveSheet =
      sheet;

    requestAnimationFrame(
      function () {

        setTimeout(
          function () {

            sheet.classList.add(
              'is-open'
            );
           document.body.classList.add('ctm-overlay-is-open');
          },
          350
        );
      }
    );
  }


  /* =========================================================
     QUICK ADD ERROR ANIMATION
  ========================================================= */

  function showError(
    element,
    className
  ) {

    if (!element) return;

    if (element._errorTimer) {
      clearTimeout(
        element._errorTimer
      );
    }

    element.classList.remove(
      className
    );

    void element.offsetWidth;

    element.classList.add(
      className
    );

    element._errorTimer =
      setTimeout(
        function () {

          element.classList.remove(
            className
          );

          element._errorTimer =
            null;

        },
        3000
      );
  }


  function showQuickAddError(
    sheet,
    button
  ) {

    showError(
      qs(
        '.ctm-qa-grid',
        sheet
      ),
      'ctm-qa-grid-error'
    );

    showError(
      button,
      'ctm-qa-btn-error'
    );

    showError(
      qs(
        '.ctm-qa-select-label',
        sheet
      ),
      'ctm-qa-label-error'
    );
  }


  /* =========================================================
     QUICK ADD SIZE SELECTION
  ========================================================= */

  function handleQuickAddSize(
    e
  ) {

    var box =
      e.target.closest(
        '.ctm-qa-size-box'
      );

    if (
      !box ||
      box.disabled
    ) {
      return;
    }

    /*
      Sold-out BIS button
    */
    if (
      box.classList.contains(
        'BIS_trigger'
      ) &&
      box.classList.contains(
        'is-disabled'
      ) &&
      box.classList.contains(
        'ctm-qa-size-box--oos'
      )
    ) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    var sheet =
      box.closest(
        '.ctm-qa-sheet'
      );

    if (!sheet) return;

    qsa(
      '.ctm-qa-size-box',
      sheet
    ).forEach(function (item) {

      item.classList.remove(
        'is-selected'
      );
    });

    box.classList.add(
      'is-selected'
    );

    var error =
      qs(
        '.ctm-qa-error-msg',
        sheet
      );

    if (error) {
      error.style.display =
        'none';
    }

    var button =
      qs(
        '.ctm-qa-atb-btn',
        sheet
      );

    if (button) {

      button.textContent =
        'Add to Bag';

      button.classList.remove(
        'ctm-qa-btn-error'
      );
    }

    var grid =
      qs(
        '.ctm-qa-grid',
        sheet
      );

    if (grid) {
      grid.classList.remove(
        'ctm-qa-grid-error'
      );
    }

    var label =
      qs(
        '.ctm-qa-select-label',
        sheet
      );

    if (label) {
      label.classList.remove(
        'ctm-qa-label-error'
      );
    }
  }


  /* =========================================================
     QUICK ADD -> ADD TO BAG
  ========================================================= */

function handleQuickAddAddToBag(e) {

  var button = e.target.closest('.ctm-qa-atb-btn');

  if (!button || button.disabled) {
    return;
  }

  var sheet = button.closest('.ctm-qa-sheet');

  if (!sheet) {
    return;
  }

  /*
   =========================================================
   QUICK ADD SELECT SIZE
   =========================================================
  */

  var currentText =
    button.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  if (
    button.classList.contains('mobile-select-size-cstm') &&
    currentText === 'select size'
  ) {

    /*
     * IMPORTANT:
     * Stop the original button action.
     */
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    /*
     * Add grid error.
     */
    var grid =
      qs('.ctm-qa-grid', sheet);

    if (grid) {
      grid.classList.remove(
        'ctm-qa-grid-error'
      );

      void grid.offsetWidth;

      grid.classList.add(
        'ctm-qa-grid-error'
      );
    }

    /*
     * Show loading dots.
     */
    showLoadingDots(button);

    /*
     * Prevent another click.
     */
    button.disabled = true;

    /*
     * Restore after 1 second.
     */
    setTimeout(function () {

      hideLoadingDots(button);

      button.disabled = false;

      /*
       * Make sure the button goes back
       * to Select Size.
       */
      var selectText =
        qs(
          '.ctm-btn-select-size',
          button
        );

      var addText =
        qs(
          '.ctm-btn-add-to-bag',
          button
        );

      if (selectText) {
        selectText.style.display =
          'block';
      }

      if (addText) {
        addText.style.display =
          'none';
      }

    }, 200);

    return;
  }


  /*
   =========================================================
   QUICK ADD ADD TO BAG
   =========================================================
  */

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var selected =
    qs(
      '.ctm-qa-size-box.is-selected',
      sheet
    );

  if (!selected) {

    showQuickAddError(
      sheet,
      button
    );

    return;
  }

  var variantId =
    selected.getAttribute(
      'data-variant-id'
    );

  if (!variantId) {
    return;
  }

  var isPdpSheet =
    sheet.id ===
    'ctm-pdp-qa-sheet';

  var originalText =
    button.textContent;

  /*
   * SHOW LOADING
   */
  showLoadingDots(button);

  button.disabled = true;

  addToCart(variantId)
    .then(function () {

      setTimeout(function () {

        if (isPdpSheet) {

          sheet.classList.remove(
            'is-open'
          );
         document.body.classList.remove('ctm-overlay-is-open');
        } else {

          closeQuickAddSheet(
            sheet
          );
        }

        hideLoadingDots(button);

        button.disabled = false;

        button.textContent =
          'Select Size';

        ctmOpenCart();

      }, 800);

    })
    .catch(function () {

      hideLoadingDots(button);

      button.disabled = false;

      button.textContent =
        'Error - try again';

      setTimeout(function () {

        button.textContent =
          originalText;

      }, 2000);

    });
}


  /* =========================================================
     QUICK ADD OPEN / CLOSE
  ========================================================= */

  function handleQuickAddOpenClose(
    e
  ) {

    var trigger =
      e.target.closest(
        '.ctm-qa-trigger'
      );

    if (trigger) {

      e.preventDefault();
      e.stopPropagation();

      var picker =
        trigger.closest(
          'collection-variant-picker'
        );

      if (!picker) return;

      var sheet =
        picker._ctmSheet ||
        qs(
          '.ctm-qa-sheet',
          picker
        );

      openQuickAddSheet(
        sheet
      );

      return;
    }

    var closeButton =
      e.target.closest(
        '.ctm-qa-close, .ctm-qa-close-btn'
      );

    var overlay =
      e.target.closest(
        '.ctm-qa-overlay'
      );

    if (
      !closeButton &&
      !overlay
    ) {
      return;
    }

    var sheet =
      e.target.closest(
        '.ctm-qa-sheet'
      );

    if (sheet) {
      closeQuickAddSheet(
        sheet
      );
    }
  }


  /* =========================================================
     DESKTOP QUICK ADD PILL
  ========================================================= */

  function handleDesktopPill(
    e
  ) {

    var pill =
      e.target.closest(
        '.ctm-dhv__pill'
      );

    if (
      !pill ||
      pill.disabled
    ) {
      return;
    }

    if (
      pill.id ===
      'BIS_trigger'
    ) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    var variantId =
      pill.getAttribute(
        'data-variant-id'
      );

    if (!variantId) return;

    var originalHTML =
      pill.innerHTML;

    pill.disabled = true;

    addToCart(variantId)
      .then(function () {

        pill.innerHTML =
          '<span class="ctm-btn-loading-dots ctm-is-visible">' +
            '<span></span>' +
            '<span></span>' +
            '<span></span>' +
          '</span>';

        setTimeout(
          function () {

            ctmOpenCart();

            pill.innerHTML =
              originalHTML;

            pill.disabled =
              false;

          },
          800
        );
      })
      .catch(function () {

        pill.innerHTML =
          originalHTML;

        pill.disabled =
          false;
      });
  }


  /* =========================================================
     SWATCH
  ========================================================= */

  function handleSwatchClick(
    e
  ) {

    var swatch =
      e.target.closest(
        '.ctm_swatches'
      );

    if (!swatch) return;

    var radio =
      qs(
        'input[type="radio"]',
        swatch
      );

    if (!radio) return;

    if (
      radio.disabled ||
      radio.dataset.available !==
        'true'
    ) {
      e.preventDefault();
      return;
    }

    if (
      e.target !== radio
    ) {
      radio.click();
    }
  }


  /* =========================================================
     QUICK ADD DRAG
  ========================================================= */

function initQADrag(sheet) {

  // Already initialized
  if (
    sheet.dataset.qaInitialized === 'true'
  ) {
    return;
  }

  var drawer =
    qs(
      '.ctm-qa-drawer',
      sheet
    );

  if (!drawer) {
    return;
  }

  sheet.dataset.qaInitialized =
    'true';

  var isDragging = false;
  var startY = 0;
  var currentY = 0;
  var startTranslate = 0;


  function getTranslateY() {

    var transform =
      window.getComputedStyle(
        drawer
      ).transform;

    if (
      !transform ||
      transform === 'none'
    ) {
      return 0;
    }

    try {

      return (
        new DOMMatrix(
          transform
        ).m42 || 0
      );

    } catch (error) {

      return 0;
    }
  }


  function getY(e) {

    if (
      e.touches &&
      e.touches.length
    ) {
      return e.touches[0].clientY;
    }

    if (
      e.changedTouches &&
      e.changedTouches.length
    ) {
      return e.changedTouches[0].clientY;
    }

    return e.clientY;
  }


  function startDrag(e) {

    if (
      !sheet.classList.contains(
        'is-open'
      )
    ) {
      return;
    }

    isDragging = true;

    startY = getY(e);
    currentY = startY;

    startTranslate =
      getTranslateY();

    drawer.style.transition =
      'none';

    sheet.classList.add(
      'is-dragging'
    );
  }


  function moveDrag(e) {

    if (!isDragging) {
      return;
    }

    currentY = getY(e);

    var deltaY =
      currentY - startY;

    var newTranslate =
      startTranslate + deltaY;

    // Prevent dragging above the original position
    if (newTranslate < 0) {
      newTranslate = 0;
    }

    // Prevent dragging below drawer height
    var maxTranslate =
      drawer.offsetHeight;

    if (
      newTranslate >
      maxTranslate
    ) {
      newTranslate =
        maxTranslate;
    }

    drawer.style.transform =
      'translate3d(0, ' +
      newTranslate +
      'px, 0)';

    if (e.cancelable) {
      e.preventDefault();
    }
  }


  function endDrag() {

    if (!isDragging) {
      return;
    }

    isDragging = false;

    sheet.classList.remove(
      'is-dragging'
    );

    var deltaY =
      currentY - startY;

    drawer.style.transition =
      '';

    // Close drawer when dragged more than 100px
    if (deltaY > 100) {

      drawer.style.transform =
        '';

      sheet.classList.remove(
        'is-open'
      );
     document.body.classList.remove('ctm-overlay-is-open');
    } else {

      // Return drawer to original position
      drawer.style.transform =
        '';
    }
  }


  /* =========================================================
     TOUCH EVENTS
  ========================================================= */

  drawer.addEventListener(
    'touchstart',
    startDrag,
    {
      passive: true
    }
  );

  window.addEventListener(
    'touchmove',
    moveDrag,
    {
      passive: false
    }
  );

  window.addEventListener(
    'touchend',
    endDrag,
    {
      passive: true
    }
  );

  window.addEventListener(
    'touchcancel',
    endDrag,
    {
      passive: true
    }
  );


  /* =========================================================
     MOUSE EVENTS
  ========================================================= */

  drawer.addEventListener(
    'mousedown',
    startDrag
  );

  window.addEventListener(
    'mousemove',
    moveDrag
  );

  window.addEventListener(
    'mouseup',
    endDrag
  );

}


/* =========================================================
   INITIALIZE ALL QA SHEETS
========================================================= */

function initAllQADrag() {

  qsa(
    '.ctm-qa-sheet'
  ).forEach(
    function (sheet) {

      initQADrag(sheet);

    }
  );
}


/* =========================================================
   INITIAL LOAD
========================================================= */

if (
  document.readyState ===
  'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    initAllQADrag
  );

} else {

  initAllQADrag();

}


/* =========================================================
   MUTATION OBSERVER
   Handles dynamically added QA sheets
========================================================= */

var qaSheetObserver =
  new MutationObserver(
    function (mutations) {

      mutations.forEach(
        function (mutation) {

          mutation.addedNodes.forEach(
            function (node) {

              if (
                node.nodeType !== 1
              ) {
                return;
              }


              /* Direct QA sheet */

              if (
                node.matches &&
                node.matches(
                  '.ctm-qa-sheet'
                )
              ) {

                initQADrag(node);

              }


              /* QA sheets inside added node */

              if (
                node.querySelectorAll
              ) {

                node
                  .querySelectorAll(
                    '.ctm-qa-sheet'
                  )
                  .forEach(
                    function (sheet) {

                      initQADrag(sheet);

                    }
                  );

              }

            }
          );

        }
      );

    }
  );


qaSheetObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);

  /* =========================================================
     CUSTOM MOBILE STICKY BAR
  ========================================================= */

  function initCustomStickyBar() {

    if (!isPDP()) return;

    if (
      qs('#ctm-sticky-bar')
    ) {
      return;
    }

    var bar =
      document.createElement(
        'div'
      );

    bar.id =
      'ctm-sticky-bar';

    bar.className =
      'container';

    bar.innerHTML =
      '<button class="ctm-sb-btn">' +

        '<span class="ctm-btn-select-size">' +
          'Select Size' +
        '</span>' +

        '<span class="ctm-btn-add-to-bag">' +
          'Add to Bag' +
        '</span>' +

        '<span class="ctm-btn-loading-dots">' +
          '<span></span>' +
          '<span></span>' +
          '<span></span>' +
        '</span>' +

      '</button>';

    document.body.appendChild(
      bar
    );

    var stickyBtn =
      qs(
        '.ctm-sb-btn',
        bar
      );


    function updateStickyText() {

      var pdpBtn =
        getPdpSubmitBtn();

      if (!pdpBtn) return;

      var selected =
        !pdpBtn.hasAttribute(
          'data-ctm-unselected'
        );

      setButtonState(
        stickyBtn,
        selected
      );
    }


    bar.addEventListener(
      'click',
      function () {

        var pdpBtn =
          getPdpSubmitBtn();

        if (!pdpBtn) return;

        if (
          pdpBtn.hasAttribute(
            'data-ctm-unselected'
          )
        ) {

          pdpSizeFieldset =
            getPdpSizeFieldset();

          if (pdpSizeFieldset) {

            pdpSizeFieldset.classList.add(
              'ctm-size-val-error'
            );

            showTemporaryLoading(
              stickyBtn,
              scrollToSizeIfNeeded,
              1000
            );
          }

          return;
        }

        showTemporaryLoading(
          stickyBtn,
          function () {
            pdpBtn.click();
          },
          1000
        );
      }
    );


    function checkBar() {

      var buyBtn =
        getPdpSubmitBtn();

      if (!buyBtn) return;

      var rect =
        buyBtn.getBoundingClientRect();

      bar.classList.toggle(
        'is-visible',
        rect.bottom < 0
      );
    }


    window.addEventListener(
      'scroll',
      checkBar,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      checkBar,
      {
        passive: true
      }
    );


    setTimeout(
      function () {

        updateStickyText();
        checkBar();

      },
      300
    );


    /*
      Observe PDP AJAX replacement.
      Debounced to avoid performance problems.
    */

    var stickyTimer = null;

    new MutationObserver(
      function () {

        clearTimeout(
          stickyTimer
        );

        stickyTimer =
          setTimeout(
            updateStickyText,
            50
          );

      }
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /* =========================================================
     FILTER SYSTEM
  ========================================================= */

  window.enableApplyFilter =
    false;


  function filterContainer() {
    return qs(
      '.ctm_colletion_filter'
    );
  }


  function updateFilterLabel() {

    var container =
      filterContainer();

    var open =
      container &&
      container.classList.contains(
        'active'
      );

    if (isMobile()) {

      qsa(
        '.filter_text_mobile'
      ).forEach(function (el) {

        el.textContent =
          open
            ? 'Hide Filter'
            : 'Show Filter';
      });

    } else {

      qsa(
        '.filter_text'
      ).forEach(function (el) {

        el.textContent =
          open
            ? 'Show Filter'
            : 'Hide Filter';
      });
    }
  }


  function openFilter() {

    var container =
      filterContainer();

    if (!container) return;

    container.classList.add(
      'active'
    );

    document.body.classList.add(
      'filter-open'
    );

    var backdrop =
      qs(
        '.ctm-filter-backdrop[data-ctm-relocated]'
      );

    if (backdrop) {
      backdrop.classList.add(
        'is-visible'
      );
    }

    updateFilterLabel();
  }


  function applyFilters() {

    window.enableApplyFilter =
      true;

    var inputs =
      qsa(
        '.checkbox-control input:checked, .sr-only-custom:checked'
      );

    if (inputs.length) {

      inputs.forEach(
        function (input) {

          input.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );
        }
      );

    } else {

      var form =
        qs(
          '.facets-form, facet-filters-form form, form.grid'
        );

      if (form) {

        form.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );
      }
    }

    setTimeout(
      function () {
        window.enableApplyFilter =
          false;
      },
      100
    );
  }


  function closeFilter(
    shouldApply
  ) {

    if (shouldApply) {
      applyFilters();
    }

    function finish() {

      var container =
        filterContainer();

      if (container) {
        container.classList.remove(
          'active'
        );
      }

      document.body.classList.remove(
        'filter-open'
      );

      var backdrop =
        qs(
          '.ctm-filter-backdrop[data-ctm-relocated]'
        );

      if (backdrop) {
        backdrop.classList.remove(
          'is-visible'
        );
      }

      updateFilterLabel();
    }

    if (isMobile()) {

      setTimeout(
        finish,
        180
      );

    } else {

      finish();
    }
  }


  function initFilterEvents() {

    $(document).on(
      'click',
      '.hide_filter',
      function (e) {

        e.stopPropagation();

        var container =
          filterContainer();

        if (
          container &&
          container.classList.contains(
            'active'
          )
        ) {

          closeFilter(false);

        } else {

          openFilter();
        }
      }
    );


    $(document).on(
      'click',
      '.apply_btn',
      function (e) {

        e.preventDefault();
        e.stopPropagation();

        closeFilter(true);
      }
    );


    $(document).on(
      'click',
      '.mobile_filter_header',
      function (e) {

        e.stopPropagation();
      }
    );


    /*
      Prevent checkbox / swatch click
      from accidentally closing filter.
    */

    $(document).on(
      'click',
      '.checkbox-control input, .sr-only-custom, .color-swatch',
      function (e) {

        e.stopPropagation();
      }
    );


    $(document).on(
      'change',
      '.checkbox-control input.checkbox',
      function () {

        $('.checkbox-control input.checkbox')
          .not(this)
          .prop(
            'checked',
            false
          );
      }
    );


    document.addEventListener(
      'change',
      function (e) {

        if (
          !e.target.matches(
            '[data-header-sort-by]'
          )
        ) {
          return;
        }

        var url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          'sort_by',
          e.target.value
        );

        url.searchParams.delete(
          'page'
        );

        window.location.href =
          url.toString();
      }
    );


    /*
      Desktop outside click
    */

    // document.addEventListener(
    //   'click',
    //   function (e) {

    //     if (isMobile()) return;

    //     var container =
    //       filterContainer();

    //     if (
    //       !container ||
    //       !container.classList.contains(
    //         'active'
    //       )
    //     ) {
    //       return;
    //     }

    //     if (
    //       e.target.closest(
    //         '.mobile_filter_header, .hide_filter'
    //       )
    //     ) {
    //       return;
    //     }

    //     /*
    //       Do not close filter when
    //       clicking inside filter content.
    //     */

    //     if (
    //       container.contains(
    //         e.target
    //       )
    //     ) {
    //       return;
    //     }

    //     closeFilter(false);
    //   }
    // );


    /*
      Relocate backdrop
    */

    var backdrop =
      qs(
        '.ctm-filter-backdrop'
      );

    if (backdrop) {

      backdrop.setAttribute(
        'data-ctm-relocated',
        'true'
      );

      document.body.appendChild(
        backdrop
      );

      backdrop.addEventListener(
        'click',
        function (e) {

          e.preventDefault();

          closeFilter(true);
        }
      );

      backdrop.addEventListener(
        'touchstart',
        function (e) {

          e.preventDefault();

          closeFilter(true);

        },
        {
          passive: false
        }
      );
    }
  }


  /* =========================================================
     SLICK MOBILE SLIDER
  ========================================================= */

  function initMobileSlider() {

    if (
      typeof $ ===
        'undefined' ||
      !$.fn.slick
    ) {
      return;
    }

    function checkSlider() {

      var slider =
        $('.mobile_slider .product-list');

      if (!slider.length) return;

      if (isMobile()) {

        if (
          !slider.hasClass(
            'slick-initialized'
          )
        ) {

          slider.slick({
            infinite: false,
            slidesToShow: 1.3,
            slidesToScroll: 1,
            arrows: false,
            swipeToSlide: true
          });
        }

      } else {

        if (
          slider.hasClass(
            'slick-initialized'
          )
        ) {

          slider.slick(
            'unslick'
          );
        }
      }
    }

    checkSlider();

    $(window).on(
      'resize',
      checkSlider
    );
  }


  /* =========================================================
     ADD TO BAG TEXT TRANSFORM
  ========================================================= */

  function fixAddToBagText() {

    qsa('.button').forEach(
      function (button) {

        if (
          button.textContent
            .trim()
            .toLowerCase() ===
          'add to bag'
        ) {

          button.style.textTransform =
            'none';
        }
      }
    );
  }


  /* =========================================================
     CHECKOUT LOADING
  ========================================================= */

  function handleCheckoutLoading(
    e
  ) {

    var button =
      e.target.closest(
        '.checkout-btn-ctm button, .cart-checkout-btn-cstm button'
      );

    if (!button) return;

    var name =
      qs(
        '.button-name-cstm',
        button
      );

    var loader =
      qs(
        '.ctm-btn-loading-dots',
        button
      );

    if (name) {
      name.style.display =
        'none';
    }

    if (loader) {
      loader.classList.add(
        'ctm-is-visible'
      );
    }
  }


  /* =========================================================
     MOBILE SELECT SIZE LOADING
  ========================================================= */



/* =========================================================
   MOBILE SELECT SIZE LOADING
========================================================= */

function initMobileSelectSize() {

  $(document).on(
    'click',
    '.mobile-select-size-cstm',
    function (e) {

      var button = this;

      /*
        IMPORTANT:
        Quick Add buttons are handled by
        handleQuickAddAddToBag().

        Do NOT run PDP Select Size logic
        for Quick Add buttons.
      */
      if (button.closest('.ctm-qa-sheet')) {
        return;
      }

      /*
        Only run for buttons whose current
        text is "Select Size".
      */
      var buttonText =
        button.textContent
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      if (buttonText !== 'select size') {
        return;
      }

      /*
        Prevent multiple clicks while loading.
      */
      if (
        button.classList.contains('ctm-loading')
      ) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      /*
        Mark as loading.
      */
      button.classList.add('ctm-loading');

      /*
        Show PDP loading dots.
      */
      showLoadingDots(button);

      /*
        Find PDP size fieldset.
      */
      pdpSizeFieldset =
        getPdpSizeFieldset();

      if (pdpSizeFieldset) {

        pdpSizeFieldset.classList.add(
          'ctm-size-val-error'
        );

        /*
          Scroll to size selector.
        */
        setTimeout(
          function () {
            scrollToSizeIfNeeded();
          },
          50
        );
      }

      /*
        Restore button after loading.
      */
      setTimeout(
        function () {

          hideLoadingDots(button);

          button.classList.remove(
            'ctm-loading'
          );

        },
        1000
      );
    }
  );
}


  /* =========================================================
     DOM READY
  ========================================================= */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      /* Privacy */
      initPrivacyBanner();

      /* Theme sticky */
      initThemeStickyBar();

      /* PDP */
      initPdpVariantLogic();

      /* Custom mobile sticky */
      initCustomStickyBar();

      /* Quick Add */
      relocateAllQuickAddSheets(
        document
      );

      initAllQADrag();

      /* Filters */
      initFilterEvents();

      /* Slick */
      initMobileSlider();

      /* Mobile loading */
      initMobileSelectSize();

      /* Text transform */
      fixAddToBagText();


      /* =====================================================
         QUICK ADD MUTATION OBSERVER
      ===================================================== */

      new MutationObserver(
        function (mutations) {

          mutations.forEach(
            function (mutation) {

              mutation.addedNodes.forEach(
                function (node) {

                  if (
                    node.nodeType !== 1
                  ) {
                    return;
                  }


                  if (
                    node.matches &&
                    node.matches(
                      'collection-variant-picker'
                    )
                  ) {

                    relocateQuickAddSheet(
                      node
                    );
                  }


                  if (
                    node.querySelectorAll
                  ) {

                    relocateAllQuickAddSheets(
                      node
                    );

                    qsa(
                      '.ctm-qa-sheet',
                      node
                    ).forEach(
                      initQADrag
                    );
                  }
                }
              );
            }
          );
        }
      ).observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }
  );


  /* =========================================================
     GLOBAL CLICK HANDLER
  ========================================================= */

  document.addEventListener(
    'click',
    function (e) {

      /*
        PDP size
      */
      handlePdpSizeClick(e);


      /*
        Sticky size pill
      */
      handleStickySizePill(e);


      /*
        Desktop quick add pill
      */
      handleDesktopPill(e);


      /*
        Quick Add open / close
      */
      handleQuickAddOpenClose(e);


      /*
        Quick Add size
      */
      handleQuickAddSize(e);


      /*
        Quick Add Add To Bag
      */
      handleQuickAddAddToBag(e);


      /*
        Swatches
      */
      handleSwatchClick(e);


      /*
        PDP submit validation
      */
      handlePdpSubmit(e);


      /*
        Theme sticky submit validation
      */
      handleThemeStickySubmit(e);


      /*
        Checkout loading
      */
      handleCheckoutLoading(e);

    },
    true
  );

})();